export default __webpack_public_path__ + "static/media/EMprint Light.938e947b.ttf";